import { lsPut, safeAwait } from 'utils/request'

export const setArticleClicked = (articleId) => {
  return safeAwait(lsPut(`/articles/${articleId}/clicks`))
}
